import React, { useState } from "react"
import { Row } from "antd"
import { TextTag, Button, PhoneInput } from "../../atoms"
import "./../MobileSignIn/MobileSignIn.scss"
import { connect } from "react-redux"
import { registerByMobile } from "../../redux/actionCreators/auth"
import { withRouter, Link } from "react-router-dom"
import { osType } from "../../utils/helpers"
import {
  CREATE_ACCOUNT,
  ALREADY_REGISTERED,
  SIGN_UP_TO,
  LOGIN_BUTTON,
  BROWSER_INFO_MSG,
  OR,
  CONTINUE_EMAIL,
  INVALID_MOBILE,
  INVALID_FLAG_SELECTED,
  PRIVACY_POLICY,
  TERMS,
  TERMS_LINK,
  PRIVACY_POLICY_LINK,
  AND,
  CONTACT_YOU_PHONE_LABEL,
  PHONE_NUMBER_REQUIRED,
} from "../../constants/messages"
import "./RegisterNewUserByMobile.scss"
import SignUpSignInFooter from "../SignUpSignInFooter/SignUpSignInFooter"
import _ from "../../utils/lodashUtils"

const RegisterNewUserByMobile = (props) => {
  const { registerByMobile, isLoading } = props
  const [mobile, setMobile] = useState("")
  const [error, setError] = useState(true)
  const [errorMsg, setErrorMsg] = useState("")
  const [formattedValue, setMobileWithformat] = useState("")
  const [country, setCountryName] = useState("")
  const reg = new RegExp("[-() ]", "g")
  const typeOfOs = osType()
  const submitData = () => {
    registerByMobile({ mobile }, false).then((response) => {
      if (_.get(response, "status") === 400) {
        setError(true)
        setErrorMsg(_.get(response.data, "error"))
      }
    })
  }

  return (
    <div className="mobile-sign-container">
      <div className="signin-text">
        <TextTag textType="spaceName">{SIGN_UP_TO}</TextTag>
        <div className="noacc-text">
          <TextTag textType="sectionTextPrimary">{ALREADY_REGISTERED}</TextTag>
          <Link to="/login">
            <TextTag textType="linkText"> {LOGIN_BUTTON}</TextTag>
          </Link>
        </div>
      </div>
      <div className="separator"></div>
      <div
        className={`telephone ${typeOfOs === "Linux" ? "" : "condition-width"}`}
      >
        <PhoneInput
          format={true}
          separateDialCode={true}
          numberType={"MOBILE"}
          placeholder={CONTACT_YOU_PHONE_LABEL}
          onPhoneNumberBlur={(isPhoneValid, number) => {
            if (!isPhoneValid && !number) {
              setError(true)
              setErrorMsg(PHONE_NUMBER_REQUIRED)
            }
          }}
          onPhoneNumberChange={(isValid, number, data, formattedValue) => {
            if (isValid) {
              setCountryName(data.name)
              let phoneNumber = formattedValue.replace(reg, "")
              setMobile(phoneNumber)
              setMobileWithformat(formattedValue)
              setError(!isValid)
            } else {
              setError(!isValid)
              setErrorMsg(INVALID_MOBILE)
            }
          }}
          onSelectFlag={(number, obj, formattedValue, isWrong) => {
            if (number !== "" && !isWrong) {
              setError(!isWrong)
              setErrorMsg(INVALID_FLAG_SELECTED)
            } else {
              setErrorMsg("")
            }
          }}
          error={error ? errorMsg : ""}
        />
      </div>

      <Button
        btnSize="large"
        btnType="primary"
        className="login-form-button"
        onClick={submitData}
        disabled={error || isLoading}
      >
        {CREATE_ACCOUNT}
      </Button>
      <h2>
        <span>{OR}</span>
      </h2>
      <Button
        btnSize="large"
        btnType="primary"
        className="login-form-button email-link"
      >
        <Link to="/register-email">{CONTINUE_EMAIL}</Link>
      </Button>
      <div className="email-link-msg">
        <SignUpSignInFooter />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  isLoading: state.loadingState.isAuthenticating,
})

export default connect(mapStateToProps, { registerByMobile })(
  withRouter(RegisterNewUserByMobile)
)
